export enum CashAdvanceAvailableEnum {
  NotAvailable = 0,
  Available = 1,
  NotFound = 2,
  NeedRetry = 3,
  GettingReleasesMetadata = 4,
  WaitingListAvailable = 5,
}
